import { FiscalPrinters } from './FiscalPrinters';

/** Printer fleet: status cards + admin CRUD/token management (Task 15). */
export function FiscalPrintersPage() {
  return <FiscalPrinters />;
}
